import { useMemo } from 'react';

/**
 * Custom hook to format milliseconds into a human-readable time string
 * @param {number} milliseconds - Time in milliseconds
 * @returns {string} Formatted time string (e.g., "2h 30m 15s")
 */
const useFormatTime = (milliseconds) => {
  console.log('milliseconds', milliseconds)
  return useMemo(() => {
    if (typeof milliseconds !== 'number' || isNaN(milliseconds)) {
      return '0s';
    }

    const totalSeconds = Math.floor(milliseconds / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    console.log('seconds', seconds)

    const parts = [];
    if (hours > 0) parts.push(`${hours}h`);
    if (minutes > 0) parts.push(`${minutes}m`);
    if (seconds > 0 || parts.length === 0) parts.push(`${seconds}s`);

    return parts.join(' ');
  }, [milliseconds]);
};

export default useFormatTime;
